import React from "react";
import { useRecordContext } from "react-admin";

type FarmingCertificationFieldProps = {
  sortable?: boolean;
  source: string;
  certifications: any;
};

export const FarmingCertificationField = (props: FarmingCertificationFieldProps) => {
  const { certifications, ...rest } = props;
  const record = useRecordContext();

  if (record === undefined) {
    return null;
  }

  const farmingCertificationIds: number[] = record[props.source];

  let label = "";
  if (farmingCertificationIds.length > 0) {
    const findCertification =
      certifications && certifications.find((certification: any) => certification.id === farmingCertificationIds[0]);

    label = `${findCertification ? findCertification.label : ""}${
      findCertification && farmingCertificationIds.length > 1 ? "、他" : ""
    }`;
  }

  return <span {...rest}>{label}</span>;
};
